/* FERO — storefront behaviour. Vanilla, no dependencies. */
(function () {
  'use strict';

  var money = function (cents) {
    return 'NT$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
  };

  /* ---------- toast ---------- */
  var toastEl = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast mono';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('on'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  }

  /* ---------- cart count ---------- */
  function paintCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }
  function refreshCart() {
    var t = nextTicket();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return applyCart(c, t); })
      .catch(function () {});
  }
  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || '無法加入購物袋'); });
      return r.json();
    });
  }

  /* Change one line of the bag. /cart/change.js answers with the whole cart, so
     the panel repaints from that answer rather than asking /cart.js again.
     A quantity of 0 is how Shopify removes a line — there is no separate call,
     which is why stepping down from 1 and pressing the × are the same request.

     `busy` is not politeness: two changes in flight at once are both computed
     against the quantity that was on screen when they were pressed, so the
     second would undo the first. */
  function postChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) {
          throw new Error(e.description || e.message || '無法更新購物袋');
        });
      }
      return r.json();
    });
  }

  /* Everything that changed the bag repaints through here, so the panel, the
     cart page, the header count and any app listening on cart:updated all see
     the same cart from the same answer.

     Every answer carries a ticket taken when its request was SENT. An answer
     whose ticket is older than the newest one already painted is dropped: on a
     slow connection a request sent first can come back last, and without this
     its out-of-date cart would overwrite the newer one and the number would
     jump back. */
  var cartTicket = 0, cartPainted = 0;
  function nextTicket() { return ++cartTicket; }
  function applyCart(c, ticket) {
    if (ticket !== undefined) {
      if (ticket < cartPainted) return c;
      cartPainted = ticket;
    }
    paintCount(c.item_count);
    renderCart(c);
    renderCartPage(c);
    /* Nothing else on the page would otherwise learn that the cart changed.
       Apps — a 超商取貨 picker, a shipping estimator — listen for this to stay
       in step. */
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
    return c;
  }

  /* One queue for every quantity change, from the panel and from the cart page
     alike. Serialised rather than parallel: two changes racing would be applied
     in whichever order the server happened to finish them, and the bag would
     settle on the loser.

     What is sent is always an absolute quantity, never "one more than what is
     on screen", so a press is never counted against a number that has already
     moved on. The panel adds its presses up itself and sends the total — which
     is why presses are no longer dropped while a change is in flight. */
  var cartQueue = Promise.resolve();
  function queueChange(key, qty) {
    cartQueue = cartQueue.then(function () {
      var t = nextTicket();
      return postChange(key, qty)
        .then(function (c) { return applyCart(c, t); })
        .catch(function (err) {
          /* the quantity was refused — most often stock ran out while the bag
             was open — so say so and put the real numbers back */
          toast(err.message || '無法更新購物袋');
          return refreshCart();
        });
    });
    return cartQueue;
  }

  /* Adds are serialised for the same reason. Each press is its own request, so
     pressing four times adds four. */
  var addQueue = Promise.resolve();
  function queueAdd(variantId, qty) {
    addQueue = addQueue.then(function () {
      return addToCart(variantId, qty).then(function () { return refreshCart(); });
    });
    return addQueue;
  }

  /* ---------- load screen ---------- */
  (function () {
    var el = document.getElementById('loader');
    if (!el) return;
    var fill = el.querySelector('.ld-fill');
    if (!fill) return;

    var MIN_SHOW = 650;   /* keep the reveal readable even on an instant load */
    var HARD_CAP = 4000;  /* a stalled asset must never hold the page hostage */
    var started = Date.now();
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var p = 0, raf = null, settled = false;

    function paint() { fill.style.clipPath = 'inset(0 ' + (100 - p).toFixed(2) + '% 0 0)'; }

    function hide() {
      el.classList.add('done');
      if (raf) cancelAnimationFrame(raf);
    }

    function finish() {
      if (settled) return;
      settled = true;
      if (raf) cancelAnimationFrame(raf);
      p = 100; paint();
      var held = Date.now() - started;
      setTimeout(hide, Math.max(0, MIN_SHOW - held) + 200);
    }

    if (still) { p = 100; paint(); hide(); return; }

    /* ease toward 90% while loading; the last 10% belongs to the load event */
    function tick() {
      if (p < 90) { p += (90 - p) * 0.055 + 0.35; paint(); raf = requestAnimationFrame(tick); }
    }
    paint();
    raf = requestAnimationFrame(tick);

    if (document.readyState === 'complete') finish();
    else addEventListener('load', finish);
    setTimeout(finish, HARD_CAP);

    function cover(then) {
      p = 0; paint();
      el.classList.remove('done');
      el.classList.add('leaving');
      setTimeout(then, 280);
    }

    /* only step back when the entry we'd land on belongs to this site — otherwise
       history.back() would throw the visitor out to wherever they came from */
    function canGoBack() {
      if (history.length <= 1) return false;
      if (!document.referrer) return false;
      try { return new URL(document.referrer).host === location.host; }
      catch (err) { return false; }
    }

    /* cover the page before leaving, so the next page's reveal continues the beat */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a');
      if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.protocol !== 'http:' && a.protocol !== 'https:') return;   /* mailto:, tel: */
      if (a.host !== location.host) return;                            /* offsite */

      if (a.hasAttribute('data-back') && canGoBack()) {
        e.preventDefault();
        cover(function () { history.back(); });
        return;
      }

      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#') return;                              /* in-page anchor */
      if (a.pathname === location.pathname && a.search === location.search) return;

      e.preventDefault();
      cover(function () { location.href = a.href; });
    });

    /* restored from bfcache: the overlay would otherwise come back mid-fade */
    addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      el.classList.remove('leaving');
      el.classList.add('done');
    });
  })();

  /* ---------- cart panel ---------- */
  var renderCart = function () {};
  (function () {
    var panel = document.getElementById('cartpanel');
    if (!panel) return;
    var list = document.getElementById('cp-list');
    var total = document.getElementById('cp-total');
    /* the blind's own cascade runs about half a second; the contents follow once
       the first slats are down, and the lift gets the same span to finish in */
    var SETTLE = 260, LIFT = 520;
    var open = false, timer = null;
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* rebuild from /cart.js so the panel stays right after an AJAX add */
    /* what the presses add up to, per line, until the server has answered */
    var cpIntent = Object.create(null);
    function paintIntent() {
      var total = 0;
      list.querySelectorAll('.cp-item').forEach(function (row) {
        var k = row.dataset.key;
        var q = (k in cpIntent) ? cpIntent[k] : Number(row.dataset.qty || 0);
        total += q;
        var n = row.querySelector('[data-cp-n]');
        if (n && n.textContent !== String(q)) n.textContent = q;
      });
      paintCount(total);
    }

    renderCart = function (cart) {
      if (!list || !cart || !cart.items) return;
      if (!cart.items.length) {
        list.innerHTML = '<li class="cp-empty mono tiny up">購物袋是空的</li>';
      } else {
        /* Same markup the Liquid renders, hrefs included: the panel is rebuilt
           after every change, and if these came back as bare buttons the
           no-script path would work only until the first repaint. */
        list.innerHTML = cart.items.map(function (it, i) {
          var line = i + 1;
          var img = it.image ? '<img src="' + esc(it.image) + '" alt="" width="40" height="50">' : '';
          var variant = (it.variant_title && it.variant_title.indexOf('Default') < 0)
            ? '<span class="mono tiny">' + esc(it.variant_title) + '</span>' : '';
          var chg = '/cart/change?line=' + line + '&quantity=';
          return '<li class="cp-item" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' + img +
            '<div class="cp-meta">' +
              '<a class="cp-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
              variant +
              '<span class="cp-qty">' +
                '<a href="' + chg + (it.quantity - 1) + '" data-cp-step="-1" aria-label="減少數量">&minus;</a>' +
                '<b data-cp-n>' + it.quantity + '</b>' +
                '<a href="' + chg + (it.quantity + 1) + '" data-cp-step="1" aria-label="增加數量">+</a>' +
              '</span>' +
            '</div>' +
            '<span class="cp-end">' +
              '<span class="mono tiny cp-price">' + money(it.final_line_price) + '</span>' +
              '<a class="cp-del" href="' + chg + '0" data-cp-remove aria-label="移除">&times;</a>' +
            '</span></li>';
        }).join('');
      }
      if (total) total.textContent = money(cart.total_price);
      /* presses still waiting for an answer stay on screen rather than being
         rolled back to the number the server last knew about */
      for (var k in cpIntent) { paintIntent(); break; }
    };

    function setExpanded(v) {
      document.querySelectorAll('[data-cart-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', v ? 'true' : 'false');
      });
    }

    function show() {
      clearTimeout(timer);
      panel.hidden = false;
      panel.classList.remove('closing');
      /* read the box back before adding .open, so the slats transition from the
         stowed state instead of being painted already down on the first frame */
      void panel.getBoundingClientRect();
      panel.classList.add('open');
      if (still) {
        panel.classList.add('filled');
      } else {
        timer = setTimeout(function () { panel.classList.add('filled'); }, SETTLE);
      }
      open = true;
      setExpanded(true);
      refreshCart();                                 /* repaint contents behind the blind */
    }

    function hide() {
      clearTimeout(timer);
      panel.classList.remove('filled', 'open');
      panel.classList.add('closing');
      timer = setTimeout(function () {
        panel.classList.remove('closing');
        panel.hidden = true;
      }, still ? 0 : LIFT);
      open = false;
      setExpanded(false);
    }

    /* capture phase: the load-screen link handler also listens for clicks on <a>,
       and would navigate to /cart before this ever ran */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cart-toggle]');
      if (!b) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;  /* let new-tab through */
      e.preventDefault();
      e.stopPropagation();
      if (open) hide(); else show();
    }, true);

    /* Capture phase, like the toggle above and for the same reason: these
       controls are <a>, and the load screen's own link handler would run the
       page-leave transition and navigate to /cart/change before this saw the
       click. Stopping it here is what keeps the change on this page. */
    document.addEventListener('click', function (e) {
      var ctl = e.target.closest('[data-cp-step],[data-cp-remove]');
      if (!ctl || !panel.contains(ctl)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var row = ctl.closest('.cp-item');
      var key = row && row.dataset.key;
      if (!key) return;                       /* no key: let the href do the work */
      e.preventDefault();
      e.stopPropagation();
      /* Presses are added up here, not read back off the screen: pressing +
         three times quickly means three, even though no answer has arrived to
         move the number in between. The total is what gets sent. */
      var base = (key in cpIntent) ? cpIntent[key] : Number(row.dataset.qty || 0);
      var qty = ctl.hasAttribute('data-cp-remove') ? 0 : Math.max(0, base + Number(ctl.dataset.cpStep));
      cpIntent[key] = qty;
      paintIntent();
      queueChange(key, qty).then(function () {
        if (cpIntent[key] === qty) delete cpIntent[key];
      });
    }, true);

    addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) hide(); });
  })();

  /* ---------- drawer ---------- */
  (function () {
    var dr = document.getElementById('drawer');
    var sc = document.getElementById('scrim');
    if (!dr || !sc) return;
    function setMenu(open) {
      dr.classList.toggle('open', open);
      sc.classList.toggle('on', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    document.querySelectorAll('[data-open-menu]').forEach(function (b) {
      b.addEventListener('click', function () { setMenu(true); });
    });
    document.querySelectorAll('[data-close-menu]').forEach(function (b) {
      b.addEventListener('click', function () { setMenu(false); });
    });
    sc.addEventListener('click', function () { setMenu(false); });
    dr.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });

    /* A title that has children opens them instead of navigating; its own URL
       is the first child, so nothing becomes unreachable. One group at a time,
       which keeps the rows on the blind's rhythm rather than piling up. */
    dr.querySelectorAll('.dr-nav .ttl[data-sub]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.item');
        var wasOpen = item.classList.contains('on');
        dr.querySelectorAll('.dr-nav .item.on').forEach(function (o) {
          o.classList.remove('on');
          var t = o.querySelector('.ttl');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          /* reading offsetWidth between the two class changes forces the layout
             to flush, so re-opening the same group replays the pointer sweep
             instead of the browser treating it as an unchanged animation */
          void item.offsetWidth;
          item.classList.add('on');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* closing the drawer folds the groups away too, so it opens clean next time */
    function foldGroups() {
      dr.querySelectorAll('.dr-nav .item.on').forEach(function (o) {
        o.classList.remove('on');
        var t = o.querySelector('.ttl');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    sc.addEventListener('click', foldGroups);
    document.querySelectorAll('[data-close-menu]').forEach(function (b) {
      b.addEventListener('click', foldGroups);
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  })();

  /* The header used to invert to white type when it crossed a dark section.
     It now carries its own white band on every page, so the type is never on
     anything but white and the inversion would have made it invisible. The
     scroll listener went with the rule it drove. */

  /* ---------- header dropdowns: Shop and Collection ---------- */
  /* The blinds used to open on :focus-within alone, which looks equivalent to a
     click and is not: Safari and Firefox on macOS deliberately do not focus a
     <button> when it is pressed, so on those browsers Shop and Collection did
     nothing at all.

     The .open class is now the only thing that opens a blind. Sharing the job
     with :focus-within does not work either, because Chrome focuses the button
     on mousedown — by the time the click handler runs the item already matches
     :focus-within, and a toggle reading that state would close what the same
     press was meant to open. Keyboards are covered without it: Enter and Space
     on a <button> fire a click like any other press. */
  (function () {
    var items = [].slice.call(document.querySelectorAll('.hnav-item'));
    if (!items.length) return;

    function close(it) {
      it.classList.remove('open');
      var b = it.querySelector('.hlink');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    function closeAll() { items.forEach(close); }

    items.forEach(function (it) {
      var btn = it.querySelector('.hlink');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var was = it.classList.contains('open');
        closeAll();
        if (!was) {
          it.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hnav-item')) closeAll();
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  })();

  /* ---------- product card image carousel ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nav');
    if (!btn) return;
    e.preventDefault();
    /* [data-i] rather than .fig, so this one handler drives both the collection
       card and the home grid's stage without a second copy of the logic */
    var fig = btn.closest('[data-i]');
    if (!fig) return;
    var slides = [].slice.call(fig.querySelectorAll('.slide'));
    if (slides.length < 2) return;
    var i = (Number(fig.dataset.i || 0) + (btn.classList.contains('next') ? 1 : -1) + slides.length) % slides.length;
    fig.dataset.i = i;
    slides.forEach(function (el, n) { el.classList.toggle('on', n === i); });
    var c = fig.querySelector('.count');
    if (c) c.textContent = pad(i + 1) + ' / ' + pad(slides.length);
  });
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- touch: swipe a photo stack to page it ---------- */
  /* A swipe presses the stack's own prev/next button rather than paging by
     itself, so the collection card, the home grid and the product page stage
     (whose rail numbers follow its arrows) each keep their one paging routine.
     The arrows are hidden on touch screens, but .click() still reaches them.

     The first few pixels of a drag decide its axis, and the decision holds
     until the finger lifts. A sideways drag then cancels every touchmove, which
     is what stops the page scrolling under a thumb that drifts up or down while
     it swipes; an up-and-down drag is never cancelled, so it scrolls as usual.
     That one listener has to be non-passive, so it sits on the photo stacks
     themselves rather than on the document — a blocking listener on the
     document would make every scroll on the page wait for the script. */
  (function () {
    var PAGERS = '[data-i], #stage';
    var SLOP = 6;           /* px before the axis is decided */
    var box = null, sx = 0, sy = 0, axis = '', swiped = 0;

    function onMove(e) {
      if (!box || e.touches.length !== 1) return;
      if (!axis) {
        var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
        if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axis === 'x' && e.cancelable) e.preventDefault();
    }
    function bind(el) {
      if (el.dataset.swipe) return;
      el.dataset.swipe = '1';
      el.addEventListener('touchmove', onMove, { passive: false });
    }
    document.querySelectorAll(PAGERS).forEach(bind);

    document.addEventListener('touchstart', function (e) {
      box = e.touches.length === 1 ? e.target.closest(PAGERS) : null;
      axis = '';
      if (!box) return;
      bind(box);  /* a stack added after load is picked up from its first touch */
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchcancel', function () { box = null; }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!box) return;
      var el = box, t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      box = null;
      if (axis === 'y' || Math.abs(dx) < 40) return;
      if (!axis && Math.abs(dx) < Math.abs(dy) * 1.5) return;
      /* finger travelling left brings the next photo in from the right */
      var btn = el.querySelector(dx < 0 ? '.next' : '.prev');
      if (!btn) return;
      swiped = Date.now();
      btn.click();
    }, { passive: true });
    /* the photo is also a link to the product; a swipe must not open it */
    document.addEventListener('click', function (e) {
      if (Date.now() - swiped > 400) return;
      var a = e.target.closest('a');
      if (a && a.closest(PAGERS)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  })();

  /* ---------- collection: size pick + quick add ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.buysizes button');
    if (!b || b.disabled) return;
    var card = b.closest('.card');
    card.querySelectorAll('.buysizes button').forEach(function (x) { x.classList.remove('sel'); });
    b.classList.add('sel');
    var add = card.querySelector('.add');
    add.disabled = false;
    add.dataset.variant = b.dataset.variant;
    /* the label stays +cart — the chosen size is shown by the filled circle in
       the row above, so repeating it on the button would say it twice */
  });

  /* The button is not taken away while the request is in flight: pressing it
     three times used to add one item and swallow the other two presses without
     saying anything. The presses queue instead, and the label goes back on a
     timer rather than on a lock. */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.add');
    if (!add || add.disabled || !add.dataset.variant) return;
    if (!add.dataset.baseLabel) add.dataset.baseLabel = add.textContent;
    var label = add.dataset.baseLabel;
    add.textContent = '加入中…';
    queueAdd(add.dataset.variant, 1)
      .then(function () {
        add.textContent = '已加入';
        toast('已加入購物袋');
        clearTimeout(add._fxLabel);
        add._fxLabel = setTimeout(function () { add.textContent = label; }, 1200);
      })
      .catch(function (err) {
        toast(err.message || '無法加入購物袋');
        add.textContent = label;
      });
  });

  /* ---------- collection: hover-driven large preview ---------- */
  (function () {
    var preview = document.getElementById('preview');
    var grid = document.getElementById('grid');
    if (!preview || !grid) return;

    var frames = [].slice.call(preview.querySelectorAll('.pv'));
    if (frames.length < 2) return;
    var cap = document.getElementById('preview-cap');
    var titles = [].slice.call(grid.querySelectorAll('.card[data-pv]')).reduce(function (map, c) {
      var nm = c.querySelector('.info .nm') || c.querySelector('h3');
      map[c.dataset.pv] = nm ? nm.textContent.trim() : '';
      return map;
    }, {});

    var active = 0;
    function show(i) {
      if (i === active || !frames[i]) return;
      frames[active].classList.remove('on');
      frames[i].classList.add('on');
      active = i;
      if (cap && titles[i] != null) cap.textContent = titles[i];
    }

    function fromEvent(e) {
      var card = e.target.closest('.card[data-pv]');
      if (!card || card.classList.contains('hide')) return;
      var i = parseInt(card.dataset.pv, 10);
      if (!isNaN(i)) show(i);
    }

    /* mouseover (not mouseenter) so one delegated listener covers every card */
    grid.addEventListener('mouseover', fromEvent);
    grid.addEventListener('focusin', fromEvent);
  })();

  /* ---------- collection: the page list ---------- */
  /* <details> gives the open and close for free but not the two things every
     other menu on this site does: shut when you press somewhere else, and shut
     on Escape. Without them the list would sit open over the grid. */
  (function () {
    var pager = document.querySelector('.pgroup');
    if (!pager) return;
    document.addEventListener('click', function (e) {
      if (pager.open && !pager.contains(e.target)) pager.open = false;
    });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pager.open) {
        pager.open = false;
        var s = pager.querySelector('summary');
        if (s) s.focus();
      }
    });
  })();

  /* ---------- collection: category filter ---------- */
  (function () {
    var filters = document.getElementById('filters');
    var grid = document.getElementById('grid');
    if (!filters || !grid) return;
    var tally = document.getElementById('tally');

    function apply(f) {
      if (!f) return;
      filters.querySelectorAll('.filter').forEach(function (x) { x.classList.toggle('on', x === f); });
      var key = f.dataset.f;
      var n = 0;
      grid.querySelectorAll('.card').forEach(function (c) {
        var cats = (c.dataset.cat || '').split(' ');
        var show = key === 'all' || cats.indexOf(key) > -1;
        c.classList.toggle('hide', !show);
        if (show) n++;
      });
      if (tally) tally.textContent = tally.dataset.prefix + ' — ' + pad(n) + ' ITEMS';
    }

    filters.addEventListener('click', function (e) {
      apply(e.target.closest('.filter'));
    });

    /* The header's Shop blind links here with ?f=top and the like, so arriving
       from a category shows that category rather than landing on 全部 and
       leaving the visitor to press it again. The row stays the one source of
       truth — the parameter only chooses which button starts pressed — so an
       unknown or missing value simply leaves the default alone. */
    var want = new URLSearchParams(location.search).get('f');
    if (want) {
      var start = filters.querySelector('.filter[data-f="' + CSS.escape(want) + '"]');
      if (start) apply(start);
    }
  })();

  /* ---------- PDP gallery ---------- */
  (function () {
    var stage = document.getElementById('stage');
    var railEl = document.getElementById('rail');
    if (!stage || !railEl) return;
    var slides = [].slice.call(stage.querySelectorAll('.slide'));
    var dots = [].slice.call(railEl.querySelectorAll('button[data-go]'));
    function show(i) {
      i = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('on', n === i); });
      dots.forEach(function (r, n) { r.classList.toggle('on', n === i); });
    }
    function cur() { return slides.findIndex(function (s) { return s.classList.contains('on'); }); }
    dots.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    var prev = railEl.querySelector('.gnav.prev');
    var next = railEl.querySelector('.gnav.next');
    if (prev) prev.addEventListener('click', function () { show(cur() - 1); });
    if (next) next.addEventListener('click', function () { show(cur() + 1); });
    addEventListener('keydown', function (e) {
      if (e.target.matches('input,textarea,select')) return;
      if (e.key === 'ArrowLeft') show(cur() - 1);
      if (e.key === 'ArrowRight') show(cur() + 1);
    });
  })();

  /* ---------- outline buttons: pleated label on hover, old-TV switch-off on press ---------- */
  /* Every button that used to be a solid black block — add to cart, the cart
     panel's 前往購物袋, and .btn (checkout, search, sign-in and the rest) — is now
     a plain frame, and its label carries two effects.

     Hover is the home category block's pleat: the label is cut into vertical
     strips and each strip slides up or down, so the word reads as printed on
     folded cloth. Strips only move along their own axis; sliding a vertical
     strip sideways tears gaps through the letters. The category labels were
     ~24px with 0.085em of travel, which is under a pixel on 11px type, so these
     use 0.22em.

     Press is an old television switching off: the label is crushed into a
     horizontal line, the line draws in to a point and dies; letting go switches
     it back on. The off sequence always plays to the end, so a quick click still
     shows it.

     Without this script the buttons are simply framed words and work the same.
     Anything that changes a label must go through btnLabel(), because the label
     is 27 copies of the text — textContent would read all of them and writing
     it would wipe the strips. */
  var FX_SEL = 'button.cart, .cp-btn, .btn';
  var FX_SLICES = 26, FX_AMP_EM = 0.22, FX_OFF = 500, FX_ON = 420;
  var fxStill = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function btnLabel(el, text) {
    if (!el) return '';
    if (text === undefined) {
      return el.dataset.fxLabel != null ? el.dataset.fxLabel : el.textContent.trim();
    }
    if (el.classList.contains('fx-btn')) fxBuild(el, text);
    else el.textContent = text;
    return text;
  }

  function fxBuild(el, text) {
    if (text == null) {
      /* only plain-text buttons are rebuilt; one holding markup is left alone */
      if (el.classList.contains('fx-btn') || el.children.length) return;
      text = el.textContent.trim();
    }
    el.dataset.fxLabel = text;
    el.classList.add('fx-btn');
    /* reuse the wrapper and line when relabelling, so a switch-off already
       running on them carries on instead of starting again */
    var wrap = el.querySelector(':scope > .lab-wrap');
    var line = el.querySelector(':scope > .crt-line');
    if (!wrap) {
      wrap = document.createElement('span'); wrap.className = 'lab-wrap';
      line = document.createElement('span'); line.className = 'crt-line';
      line.setAttribute('aria-hidden', 'true');
      el.replaceChildren(wrap, line);
    }
    var base = document.createElement('span');
    base.className = 'labin base';
    base.textContent = text;
    var parts = [base];
    var amp = (parseFloat(getComputedStyle(el).fontSize) || 11) * FX_AMP_EM, step = 100 / FX_SLICES;
    for (var s = 0; s < FX_SLICES; s++) {
      var c = base.cloneNode(true);
      c.className = 'labin slice';
      c.setAttribute('aria-hidden', 'true');
      c.style.setProperty('--i', s);
      c.style.clipPath = 'inset(0 ' + (100 - (s + 1) * step).toFixed(3) + '% 0 ' + (s * step).toFixed(3) + '%)';
      c.style.setProperty('--dy', ((Math.sin(s * 0.55) + Math.sin(s * 1.9) * 0.35) * amp).toFixed(2) + 'px');
      parts.push(c);
    }
    wrap.replaceChildren.apply(wrap, parts);
  }

  document.querySelectorAll(FX_SEL).forEach(function (el) { fxBuild(el); });
  /* buttons written in later (the emptied cart page's 繼續選購) are built the
     first time a pointer or focus reaches them */
  ['pointerover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var el = e.target.closest && e.target.closest(FX_SEL);
      if (el) fxBuild(el);
    }, { passive: true });
  });

  var fxHeld = null;
  function fxOff(el) {
    if (fxStill || el.disabled) return;
    fxBuild(el);
    clearTimeout(el._fxT);
    el.style.setProperty('--crt-w', el.querySelector('.lab-wrap').offsetWidth + 'px');
    el.classList.remove('crt-on');
    void el.offsetWidth;            /* restart the animation if it was mid-way */
    el.classList.add('crt-off');
    el._fxDown = performance.now();
    fxHeld = el;
  }
  function fxOn(el) {
    if (!el || !el.classList.contains('crt-off')) return;
    if (fxHeld === el) fxHeld = null;
    clearTimeout(el._fxT);
    el._fxT = setTimeout(function () {
      el.classList.remove('crt-off');
      void el.offsetWidth;
      el.classList.add('crt-on');
      el._fxT = setTimeout(function () { el.classList.remove('crt-on'); }, FX_ON);
    }, Math.max(0, FX_OFF - (performance.now() - el._fxDown)));
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;
    var el = e.target.closest(FX_SEL);
    if (el) fxOff(el);
  }, { passive: true });
  ['pointerup', 'pointercancel'].forEach(function (type) {
    document.addEventListener(type, function () { fxOn(fxHeld); }, { passive: true });
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
      var el = e.target.closest && e.target.closest(FX_SEL);
      if (el) fxOff(el);
    }
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Enter' || e.key === ' ') fxOn(fxHeld);
  });

  /* ---------- PDP variant picker ---------- */
  (function () {
    var wrap = document.getElementById('pdp-sizes');
    if (!wrap) return;
    var idInput = document.getElementById('pdp-variant-id');
    var stock = document.getElementById('stock');
    var priceEl = document.getElementById('pdp-price');
    var cartBtn = document.getElementById('pdp-add');

    function select(b) {
      wrap.querySelectorAll('button').forEach(function (x) { x.classList.remove('sel'); });
      b.classList.add('sel');
      idInput.value = b.dataset.variant;
      if (priceEl && b.dataset.price) priceEl.innerHTML = money(Number(b.dataset.price));
      var qty = Number(b.dataset.qty || 0);
      var tracked = b.dataset.tracked === 'true';
      if (stock) {
        if (!tracked) stock.textContent = b.textContent.trim() + ' — 現貨';
        else if (qty <= 0) stock.textContent = b.textContent.trim() + ' — 已售完';
        else if (qty <= 3) stock.textContent = b.textContent.trim() + ' — 僅剩 ' + qty + ' 件';
        else stock.textContent = b.textContent.trim() + ' — 現貨';
      }
      if (cartBtn) {
        var sold = tracked && qty <= 0;
        cartBtn.disabled = sold;
        btnLabel(cartBtn, sold ? '已售完' : '加入購物袋');
      }
      try {
        var u = new URL(window.location);
        u.searchParams.set('variant', b.dataset.variant);
        history.replaceState({}, '', u);
      } catch (e) {}
    }

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.disabled) return;
      select(b);
    });

    var preset = wrap.querySelector('button.sel') || wrap.querySelector('button:not(.out)');
    if (preset) select(preset);
  })();

  /* ---------- PDP add to cart (AJAX) ---------- */
  (function () {
    var form = document.getElementById('pdp-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('pdp-add');
      var id = document.getElementById('pdp-variant-id').value;
      /* btn.disabled here is the sold-out state the variant picker sets — that
         one still stands. The button is no longer disabled by the request
         itself, so pressing twice adds two. */
      if (!id || btn.disabled) return;
      if (!btn.dataset.baseLabel) btn.dataset.baseLabel = btnLabel(btn);
      var label = btn.dataset.baseLabel;
      btnLabel(btn, '加入中…');
      queueAdd(id, 1)
        .then(function () {
          btnLabel(btn, '已加入購物袋');
          toast('已加入購物袋');
          clearTimeout(btn._fxLabel);
          btn._fxLabel = setTimeout(function () { btnLabel(btn, label); }, 1200);
        })
        .catch(function (err) {
          toast(err.message || '無法加入購物袋');
          btnLabel(btn, label);
        });
    });
  })();

  /* ---------- hero: the season code rides the pointer ---------- */
  (function () {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var tag = hero.querySelector('[data-hero-cursor]');
    /* only where there is a real pointer: hiding the cursor on a touch screen
       would take something away and give nothing back */
    if (!tag || !matchMedia('(pointer: fine)').matches) return;

    var x = 0, y = 0, queued = false;
    function paint() {
      queued = false;
      tag.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    }

    hero.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      /* sat down and to the right of the hotspot, the way a cursor label sits,
         so it never covers the point being aimed at */
      x = e.clientX + 15;
      y = e.clientY + 13;
      tag.classList.add('on');
      /* one paint per frame — pointermove fires far faster than the screen */
      if (!queued) { queued = true; requestAnimationFrame(paint); }
    }, { passive: true });

    hero.addEventListener('pointerleave', function () { tag.classList.remove('on'); });
    addEventListener('blur', function () { tag.classList.remove('on'); });
  })();

  /* ---------- cart page ---------- */
  /* This used to answer every change with window.location.reload(), which threw
     away the page to repaint three numbers. Nothing here needs the server to
     re-render: /cart/change.js already answers with the whole cart, so the line
     totals, the grand total and the count are all in hand. Rows are matched by
     item key rather than position, because removing a line renumbers the rest. */
  function renderCartPage(cart) {
    var rows = document.getElementById('cart-rows');
    if (!rows || !cart || !cart.items) return;

    var live = {};
    cart.items.forEach(function (it) { live[it.key] = it; });

    [].slice.call(rows.querySelectorAll('[data-line-key]')).forEach(function (tr) {
      var it = live[tr.dataset.lineKey];
      if (!it) { tr.remove(); return; }              /* removed, or quantity hit 0 */
      var cell = tr.querySelector('[data-line-total]');
      if (cell) cell.textContent = money(it.final_line_price);
      /* the server may have clamped the quantity to what stock allows, so the
         field is set from the answer rather than left showing what was typed */
      var input = tr.querySelector('[data-cart-qty]');
      if (input && Number(input.value) !== it.quantity) input.value = it.quantity;
    });

    var tot = document.querySelector('[data-cart-total]');
    if (tot) tot.textContent = money(cart.total_price);

    /* An empty bag is a different page — no table, no totals, no checkout — so
       the live region is replaced with the same empty state the Liquid renders
       rather than leaving an empty table and a 前往結帳 button behind. */
    if (!cart.items.length) {
      var wrap = document.getElementById('cart-live');
      if (wrap) {
        var p = document.createElement('p');
        p.className = 'empty mono tiny up';
        p.textContent = '購物袋是空的。';
        var a = document.createElement('a');
        a.className = 'btn ghost';
        a.href = '/collections/all';
        a.textContent = '繼續選購';
        wrap.replaceChildren(p, a);
      }
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var qty = Math.max(0, Number(input.value) || 0);
    queueChange(input.dataset.key, qty);
  });

  /* Capture phase, same reason as in the panel: 移除 is a real link to Shopify's
     remove URL so it still works without scripts, and the load screen's link
     handler would otherwise run the page-leave transition and navigate. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-remove]');
    if (!link || !link.dataset.key) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    queueChange(link.dataset.key, 0);
  }, true);

  refreshCart();
})();
